import React from "react";
import { useHistory } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import exportPDF from "../../services/exportPDF";
import exportCSV from "../../services/exportCSV";
import Paper from "@material-ui/core/Paper";
import MaterialTable from "material-table";
import Edit from "@material-ui/icons/Edit";
import { Grid } from "@material-ui/core";
import { tableIcons } from "../../shared/TableIcons";
import RotateLeft from "@material-ui/icons/RotateLeft";
import * as actions from "../../store/actions/index";
import { connect } from "react-redux";
import styles from "../../shared/dashboardStyle";
import { Card, CardHeader, CardBody } from "../../shared/Card/Index";
import "./Alerts.css";

const useStyles = makeStyles(styles);

export function AlertsTableMedium(props) {
  const classes = useStyles();

  const columns = [
    {
      field: "id",
      title: "Αρ. Ειδοποίησης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "value",
      title: "Τιμή Ειδοποίησης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "dateCreated",
      title: "Ημερομηνία",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },

    {
      field: "alarmSeverity",
      title: "Δείκτης Κινδύνου",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "alarmType",
      title: "Τύπος Ειδοποίησης",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
    {
      field: "statusDescription",
      title: "Κατάσταση",
      cellStyle: {
        width: 20,
        maxWidth: 20,
      },
      headerStyle: {
        width: 20,
        maxWidth: 20,
      },
    },
  ];

  return (

    <Grid item xs={12} style={{ marginTop: "16px" }}>
      <MaterialTable
        icons={tableIcons}
        title=""
        columns={columns}
        data={props.alarms}
        localization={{
          body: {
            emptyDataSourceMessage: "Δεν υπάρχουν Εγγραφές",
            filterRow: {
              filterTooltip: 'Φίλτρο',
              filterPlaceHolder: 'Αναζήτηση'
            }
          },
          toolbar: {
            addRemoveColumns: "Προσθέστε η αφαιρέστε κολώνες",
            showColumnsTitle: "Δείξτε κολώνες",
            addTooltip: "Προσθήκη",
            searchTooltip: "Αναζήτηση",
            searchPlaceholder: "Αναζήτηση",
            exportTitle: "Εξαγωγή",
            exportAriaLabel: "Εξαγωγή",
            exportCSVName: "Εξαγωγή σε CSV",
            exportPDFName: "Εξαγωγή σε PDF",

          },
          pagination: {
            firstTooltip: "Πρώτη Σελίδα",
            lastTooltip: "Τελευταία Σελίδα",
            previousTooltip: "Προηγούμενη Σελίδα",
            nextTooltip: "Επόμενη Σελίδα",
            labelDisplayedRows: "{from}-{to} από {count}",
            labelRowsSelect: "Εγγραφές ανά Σελίδα",
          },
          grouping: {
            placeholder: "Σύρετε για να ομαδοποιήσετε",
            groupedBy: "Σύρετε για να ομαδοποιήσετε",

          },
          header: {
            actions: "Ενέργειες",
          },
        }}
        options={{
          pageSize: 5,
          pageSizeOptions: [5, 10, 15],
          searchFieldAlignment: "left",
          columnsButton: false,
          exportButton: true,
          exportPdf: (columns, data) => {
            exportPDF(columns, data);
          }, exportCsv: (columns, data) => {
            exportCSV(columns, data);
          },
          search: false,
          grouping: false,
          sorting: false,
          filtering: true,
          exportAllData: true,
        }}
      />
    </Grid>
  );


}


export function AlertsTableBig(props) {
  const classes = useStyles();

  let history = useHistory();

  let actions = [
    {
      icon: () => <Edit />,
      tooltip: "Επεξεργασία",
      onClick: (e, row) => {
        history.push({
          pathname: "/alert-take-over",
          selected: row.id,
          localPath: props.localPath
        });
      }
    }
  ];



  return (
    <Grid item xs={12} style={{ marginTop: "16px" }}>
      <Card>
        <CardHeader color="warning">
          <h1 className={classes.cardTitleWhite}>{props.title}</h1>
        </CardHeader>
        <CardBody>
          <MaterialTable
            icons={tableIcons}
            isLoading={props.isLoading}
            title=""
            columns={props.columns}
            data={props.alerts}
            actions={actions}
            localization={{
              body: {
                emptyDataSourceMessage: "Δεν υπάρχουν Εγγραφές",
                filterRow: {
                  filterTooltip: 'Φίλτρο',
                  filterPlaceHolder: 'Αναζήτηση'
                }
              },
              toolbar: {
                addRemoveColumns: "Προσθέστε η αφαιρέστε κολώνες",
                showColumnsTitle: "Δείξτε κολώνες",
                addTooltip: "Προσθήκη",
                searchTooltip: "Αναζήτηση",
                searchPlaceholder: "Αναζήτηση",
                exportTitle: "Εξαγωγή",
                exportAriaLabel: "Εξαγωγή",
                exportCSVName: "Εξαγωγή σε CSV",
                exportPDFName: "Εξαγωγή σε PDF",

              },
              pagination: {
                firstTooltip: "Πρώτη Σελίδα",
                lastTooltip: "Τελευταία Σελίδα",
                previousTooltip: "Προηγούμενη Σελίδα",
                nextTooltip: "Επόμενη Σελίδα",
                labelDisplayedRows: "{from}-{to} από {count}",
                labelRowsSelect: "Εγγραφές ανά Σελίδα",

              },
              grouping: {
                placeholder: "Σύρετε για να ομαδοποιήσετε",
                groupedBy: "Σύρετε για να ομαδοποιήσετε",

              },
              header: {
                actions: "Ενέργειες",
              },
            }}
            options={{
              pageSize: 10,
              pageSizeOptions: [10, 15, 20],
              searchFieldAlignment: "left",
              columnsButton: true,
              exportButton: true,
              exportPdf: (columns, data) => {
                exportPDF(columns, data);
              }, exportCsv: (columns, data) => {
                exportCSV(columns, data);
              },
              search: false,
              grouping: true,
              sorting: true,
              filtering: true,
              exportAllData: true,
            }}
          />
        </CardBody>
      </Card>
    </Grid>
  );
}



const mapStateToProps = (state) => {
  return {
    ...state.map,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    editMapState: (mapPayload) => {
      dispatch(actions.editMapStateAsync(mapPayload));
    },
  };
};

export const AlertsTableBigForHome = connect(
  mapStateToProps,
  mapDispatchToProps
)((props) => {


  let history = useHistory();

  const { editMapState } = props;


  const actions = [
    {
      icon: () => <RotateLeft />,
      tooltip: "Όλοι οι Ωφελούμενοι",
      onClick: () => {
        editMapState({
          objectForTableFiltering: {
            beneficiaryId: null,
            alertScore: null,
          },
        });
      },
      isFreeAction: true,
    },
    {
      icon: () => <Edit />,
      tooltip: "Επεξεργασία",
      onClick: (e, row) => {
        history.push({
          pathname: "/alert-take-over",
          selected: row.id,
        });
      },
    },
  ];

  return (
    <Grid item xs={12} style={{ marginTop: "16px" }}>
      <MaterialTable
        icons={tableIcons}
        title=""
        columns={props.columns}
        data={props.alarms}
        actions={actions}
        localization={{
          body: {
            emptyDataSourceMessage: "Δεν υπάρχουν Εγγραφές",
            filterRow: {
              filterTooltip: 'Φίλτρο',
              filterPlaceHolder: 'Αναζήτηση'
            }
          },
          toolbar: {
            addRemoveColumns: "Προσθέστε η αφαιρέστε κολώνες",
            showColumnsTitle: "Δείξτε κολώνες",
            addTooltip: "Προσθήκη",
            searchTooltip: "Αναζήτηση",
            searchPlaceholder: "Αναζήτηση",
            exportTitle: "Εξαγωγή",
            exportAriaLabel: "Εξαγωγή",
            exportCSVName: "Εξαγωγή σε CSV",
            exportPDFName: "Εξαγωγή σε PDF",
          },
          pagination: {
            firstTooltip: "Πρώτη Σελίδα",
            lastTooltip: "Τελευταία Σελίδα",
            previousTooltip: "Προηγούμενη Σελίδα",
            nextTooltip: "Επόμενη Σελίδα",
            labelDisplayedRows: "{from}-{to} από {count}",
            labelRowsSelect: "Εγγραφές ανά Σελίδα",
          },

          grouping: {
            placeholder: "Σύρετε για να ομαδοποιήσετε",
            groupedBy: "Σύρετε για να ομαδοποιήσετε",
          },
          header: {
            actions: "Ενέργειες",
          },
        }}
        options={{
          exportPdf: (columns, data) => {
            exportPDF(columns, data);
          },
          exportCsv: (columns, data) => {
            exportCSV(columns, data);
          },
          exportAllData: true,
          searchFieldAlignment: "left",
          columnsButton: true,
          exportButton: true,
          grouping: true,
          sorting: true,
          filtering: true,
          search: false
        }}
      />
    </Grid>
  );
});
